// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.integrations-container {
  background: transparent;
}

.integrations-header {
  margin-bottom: 24px;
}

.integrations-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  background: transparent;
  border-bottom: 1px solid #e0e6eb;
  border-radius: 4px;
  padding: 12px 30px;
}

.search-container {
  position: relative;
  flex: 1 1;
  max-width: 100%;
  min-width: 300px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  padding: 0;
  gap: 12px;
}

.search-icon {
  flex-shrink: 0;
}

.search-input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #142a31;
  outline: none;
}
.search-input::placeholder {
  color: #6a8991;
}

.filter-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 13px;
  background: #ffffff;
  border: 1px solid #d3e1ed;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #142a31;
  cursor: pointer;
}
.filter-dropdown span {
  color: #142a31;
}
.filter-dropdown select {
  border: none;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #142a31;
  cursor: pointer;
  outline: none;
  appearance: none;
  padding-right: 20px;
}
.filter-dropdown .dropdown-icon {
  position: absolute;
  right: 13px;
  pointer-events: none;
}

.integrations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(265px, 1fr));
  gap: 24px;
  margin-top: 24px;
  padding: 0 30px;
}

.integration-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 10px 16px 0px rgba(129, 155, 163, 0.07);
  display: flex;
  flex-direction: column;
  position: relative;
}

.integration-logo-container {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.integration-logo {
  width: 125px;
  height: auto;
  max-height: 66px;
  object-fit: contain;
  display: block;
}

.integration-name {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 8px 0;
}

.integration-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
  margin: 0 0 20px 0;
  flex: 1 1;
}

.integration-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-direction: row;
}

.integration-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.category-tag {
  padding: 7px 9px;
  background: transparent;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #142a31;
  display: inline-block;
}

.coming-soon-tag {
  padding: 7px 9px;
  background: #DBE7F1;
  border: 1px solid #d3e1ed;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #6A8991;
  display: inline-block;
  cursor: not-allowed;
}

.status-tag {
  padding: 7px 13px;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  display: inline-block;
}
.status-tag.active {
  background: rgba(64, 160, 193, 0.2);
  color: #40a0c1;
}
.status-tag.inactive {
  background: #142a31;
  color: #ffffff;
}
.status-tag.settings-tag {
  cursor: pointer;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 13px;
  transition: opacity 0.2s;
  text-transform: capitalize;
}
.status-tag.settings-tag:hover {
  opacity: 0.8;
}
.status-tag.settings-tag img {
  width: 21px;
  height: 21px;
  display: block;
}

.connect-button {
  padding: 7px 9px;
  background: #142a31;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.connect-button:hover {
  background: #1f3d47;
}

.connect-modal .popupContainer {
  width: 427px;
  min-height: 295px;
  padding: 0;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27);
  display: flex;
  flex-direction: column;
}
.connect-modal .titleRow {
  display: none;
}
.connect-modal .contentContainer {
  padding: 38px 85px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1 1;
}

.connect-modal-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.connect-modal-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 38px 0;
  text-align: center;
}

.connect-modal-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
  margin: 0 0 24px 0;
  text-align: center;
  max-width: 250px;
}

.connect-modal-flow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0 0 41px 0;
  width: 120px;
  height: 34px;
  position: relative;
}

.connect-modal-flow-image-left {
  width: 21px;
  height: 27px;
  object-fit: contain;
}

.connect-modal-flow-image-right {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.connect-modal-flow-arrows {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 7.47px;
}

.connect-modal-arrow {
  width: 4.2px;
  height: 7.47px;
  display: block;
}

.connect-modal-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
}

.connect-modal-button {
  padding: 8px 29px;
  background: #142b31;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.21;
  cursor: pointer;
  transition: background 0.2s;
  min-width: 139px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.connect-modal-button:hover {
  background: #1f3d47;
}
.connect-modal-button:disabled {
  background: #a0b4b9;
  cursor: not-allowed;
}

.connect-modal-icon {
  width: 18px;
  height: 18px;
  display: block;
}

.connected-modal .popupContainer {
  width: 427px;
  min-height: 287px;
  padding: 0;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27);
  display: flex;
  flex-direction: column;
}
.connected-modal .titleRow {
  display: none;
}
.connected-modal .contentContainer {
  padding: 50px 90px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1 1;
}

.connected-modal-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.connected-modal-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0 0 48px 0;
  text-align: center;
}

.connected-modal-flow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 47px;
  margin: 0 0 52px 0;
  width: 100%;
  height: 34px;
  position: relative;
}

.connected-modal-flow-image-left {
  width: 21px;
  height: 27px;
  object-fit: contain;
}

.connected-modal-flow-image-right {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.connected-modal-link-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.connected-modal-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
}

.connected-modal-button {
  padding: 8px 15px;
  background: #142b31;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.21;
  cursor: pointer;
  transition: background 0.2s;
  min-width: 53px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.connected-modal-button:hover {
  background: #1f3d47;
}

.connected-modal-icon {
  width: 18px;
  height: 18px;
  display: block;
}

@media (max-width: 768px) {
  .integrations-grid {
    grid-template-columns: 1fr;
  }
  .search-container {
    min-width: 100%;
  }
  .integrations-controls {
    flex-direction: column;
    align-items: stretch;
  }
  .connect-modal .modal-container {
    width: 90vw;
    max-width: 427px;
  }
  .connect-modal-content {
    padding: 30px 20px;
  }
  .connected-modal .popupContainer {
    width: 90vw;
    max-width: 427px;
  }
  .connected-modal-content {
    padding: 30px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Integrations/integrations.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,uDAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAHF;;AAMA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAHF;;AAMA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAHF;AAKE;EACE,mCAAA;EACA,cAAA;AAHJ;AAME;EACE,mBAAA;EACA,cAAA;AAJJ;AAOE;EACE,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;AALJ;AAOI;EACE,YAAA;AALN;AAQI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AANN;;AAWA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AARF;AAUE;EACE,mBAAA;AARJ;;AAcE;EACE,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDAAA;EACA,aAAA;EACA,sBAAA;AAXJ;AAcE;EACE,aAAA;AAZJ;AAeE;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAbJ;;AAiBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAdF;;AAiBA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdF;AAgBE;EACE,mBAAA;AAdJ;AAiBE;EACE,mBAAA;EACA,mBAAA;AAfJ;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAhBF;;AAqBE;EACE,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDAAA;EACA,aAAA;EACA,sBAAA;AAlBJ;AAqBE;EACE,aAAA;AAnBJ;AAsBE;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AArBF;;AAwBA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBF;AAuBE;EACE,mBAAA;AArBJ;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAtBF;;AA0BA;EACE;IACE,0BAAA;EAvBF;EA0BA;IACE,eAAA;EAxBF;EA2BA;IACE,sBAAA;IACA,oBAAA;EAzBF;EA6BE;IACE,WAAA;IACA,gBAAA;EA3BJ;EA+BA;IACE,kBAAA;EA7BF;EAiCE;IACE,WAAA;IACA,gBAAA;EA/BJ;EAmCA;IACE,kBAAA;EAjCF;AACF","sourcesContent":[".integrations-container {\n  background: transparent;\n}\n\n.integrations-header {\n  margin-bottom: 24px;\n}\n\n.integrations-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  background: transparent;\n  border-bottom: 1px solid #e0e6eb;\n  border-radius: 4px;\n  padding: 12px 30px;\n}\n\n.search-container {\n  position: relative;\n  flex: 1;\n  max-width: 100%;\n  min-width: 300px;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  gap: 12px;\n}\n\n.search-icon {\n  flex-shrink: 0;\n}\n\n.search-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: #142a31;\n  outline: none;\n\n  &::placeholder {\n    color: #6a8991;\n  }\n}\n\n.filter-dropdown {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 13px;\n  background: #ffffff;\n  border: 1px solid #d3e1ed;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: #142a31;\n  cursor: pointer;\n\n  span {\n    color: #142a31;\n  }\n\n  select {\n    border: none;\n    background: transparent;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    color: #142a31;\n    cursor: pointer;\n    outline: none;\n    appearance: none;\n    padding-right: 20px;\n  }\n\n  .dropdown-icon {\n    position: absolute;\n    right: 13px;\n    pointer-events: none;\n  }\n}\n\n.integrations-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(265px, 1fr));\n  gap: 24px;\n  margin-top: 24px;\n  padding: 0 30px;\n}\n\n.integration-card {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0px 10px 16px 0px rgba(129, 155, 163, 0.07);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.integration-logo-container {\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.integration-logo {\n  width: 125px;\n  height: auto;\n  max-height: 66px;\n  object-fit: contain;\n  display: block;\n}\n\n.integration-name {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 8px 0;\n}\n\n.integration-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0 0 20px 0;\n  flex: 1;\n}\n\n.integration-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-direction: row;\n}\n\n.integration-tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.category-tag {\n  padding: 7px 9px;\n  background: transparent;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #142a31;\n  display: inline-block;\n}\n\n.coming-soon-tag {\n  padding: 7px 9px;\n  background: #DBE7F1;\n  border: 1px solid #d3e1ed;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #6A8991;\n  display: inline-block;\n  cursor: not-allowed;\n}\n\n.status-tag {\n  padding: 7px 13px;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  display: inline-block;\n\n  &.active {\n    background: rgba(64, 160, 193, 0.2);\n    color: #40a0c1;\n  }\n\n  &.inactive {\n    background: #142a31;\n    color: #ffffff;\n  }\n\n  &.settings-tag {\n    cursor: pointer;\n    border: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 7px 13px;\n    transition: opacity 0.2s;\n    text-transform: capitalize;\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    img {\n      width: 21px;\n      height: 21px;\n      display: block;\n    }\n  }\n}\n\n.connect-button {\n  padding: 7px 9px;\n  background: #142a31;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n// Connect Modal Styles\n.connect-modal {\n  .popupContainer {\n    width: 427px;\n    min-height: 295px;\n    padding: 0;\n    background: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .titleRow {\n    display: none;\n  }\n\n  .contentContainer {\n    padding: 38px 85px !important;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    flex: 1;\n  }\n}\n\n.connect-modal-content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.connect-modal-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 38px 0;\n  text-align: center;\n}\n\n.connect-modal-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0 0 24px 0;\n  text-align: center;\n  max-width: 250px;\n}\n\n.connect-modal-flow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin: 0 0 41px 0;\n  width: 120px;\n  height: 34px;\n  position: relative;\n}\n\n.connect-modal-flow-image-left {\n  width: 21px;\n  height: 27px;\n  object-fit: contain;\n}\n\n.connect-modal-flow-image-right {\n  width: 34px;\n  height: 34px;\n  object-fit: contain;\n}\n\n.connect-modal-flow-arrows {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 7.47px;\n}\n\n.connect-modal-arrow {\n  width: 4.2px;\n  height: 7.47px;\n  display: block;\n}\n\n.connect-modal-button-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n}\n\n.connect-modal-button {\n  padding: 8px 29px;\n  background: #142b31;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.21;\n  cursor: pointer;\n  transition: background 0.2s;\n  min-width: 139px;\n  height: 33px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: #1f3d47;\n  }\n\n  &:disabled {\n    background: #a0b4b9;\n    cursor: not-allowed;\n  }\n}\n\n.connect-modal-icon {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n// Connected Modal Styles\n.connected-modal {\n  .popupContainer {\n    width: 427px;\n    min-height: 287px;\n    padding: 0;\n    background: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .titleRow {\n    display: none;\n  }\n\n  .contentContainer {\n    padding: 50px 90px !important;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    flex: 1;\n  }\n}\n\n.connected-modal-content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.connected-modal-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0 0 48px 0;\n  text-align: center;\n}\n\n.connected-modal-flow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 47px;\n  margin: 0 0 52px 0;\n  width: 100%;\n  height: 34px;\n  position: relative;\n}\n\n.connected-modal-flow-image-left {\n  width: 21px;\n  height: 27px;\n  object-fit: contain;\n}\n\n.connected-modal-flow-image-right {\n  width: 34px;\n  height: 34px;\n  object-fit: contain;\n}\n\n.connected-modal-link-icon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.connected-modal-button-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n}\n\n.connected-modal-button {\n  padding: 8px 15px;\n  background: #142b31;\n  color: #ffffff;\n  border: none;\n  border-radius: 45px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.21;\n  cursor: pointer;\n  transition: background 0.2s;\n  min-width: 53px;\n  height: 33px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: #1f3d47;\n  }\n}\n\n.connected-modal-icon {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .integrations-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .search-container {\n    min-width: 100%;\n  }\n\n  .integrations-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .connect-modal {\n    .modal-container {\n      width: 90vw;\n      max-width: 427px;\n    }\n  }\n\n  .connect-modal-content {\n    padding: 30px 20px;\n  }\n\n  .connected-modal {\n    .popupContainer {\n      width: 90vw;\n      max-width: 427px;\n    }\n  }\n\n  .connected-modal-content {\n    padding: 30px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
